import React from "react"

import HotelSectionContentOne from "./HotelSectionContentOne"

import "./HotelSection.scss"

const HotelSection = (props) => {
  return (
    <section className="hotel-section">
      <div className="hotel-section__container">
        { props.locations.map((item, index) => {
          return (
            <div className="hotel-section__container__item" key={index}>
              <HotelSectionContentOne {...item} />
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default HotelSection
